















































































import { Component, Prop } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import Ajax from "@/lib/ajax";
import Coupon from "@/store/entities/booking/coupon";
import moment from "moment";

class PostData {
  supplierId: number | null = null;
  couponId: number = 0;
}

@Component({
  components: {},
})
export default class couponModel extends AbpBase {
  @Prop({ type: Boolean, default: false })
  value: boolean;
  @Prop({ type: Number, default: 0 })
  couponId: number;
  coupon: Coupon;
  postData = new PostData();
  tabName: string = "supplierId";
  phoneNumber: string = "";
  offers: any = [];
  courtList: any = [];
  couponContent: string = "";
  list:any=[];

  getTime(value) {
    return Util.int2time(value);
  }

  cancel() {
    this.$emit("input", false);
  }

  closeTable() {
    this.$emit("input", false);
    this.$emit("getPage");
  }

  

  get couponTypeList() {
    return this.$store.state.common.couponTypes;
  }



  /**
   * @description:弹窗发生改变事件
   */
  async visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
      this.postData = new PostData();
      this.$emit("getPage");
    } else {
      if (this.couponId) {
        this.list = await this.$store.dispatch({
          type: "coupon/getListByCouponId",
          id: this.$props.couponId,
        });

      }
    }
  }
}
